// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-legend[data-v-29111010]{overflow:hidden;margin-top:-30px}", ""]);
// Exports
module.exports = exports;
